/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

import moment from '@/moment'
import gt from 'gettext'
import Backbone from 'backbone'

export default Backbone.Model.extend({
  ref: 'io.ox/mail/compose/scheduled/model/',
  defaults: () => {
    return {
      date: moment(),
      time: moment().add(1, 'h')
    }
  },
  getTimestamp: function () {
    const hour = moment(this.get('time')).hour()
    const minute = moment(this.get('time')).minute()
    return moment(this.get('date')).hour(hour).minute(minute)
  },
  validate: function (attr, { time }) {
    if (time) {
      if (time <= moment().valueOf()) return gt('Date must be in the future.')
    } else {
      if (this.getTimestamp().valueOf() <= moment().valueOf()) return gt('Date must be in the future.')
    }
  }
})
